import moment from "moment";
import { isInternal, isProjectReadOnlyRole } from "../../../../redux/actions/userAction";
import { REQUEST_NOTES, REQUEST_STATUSES } from "../../../shared/constants/RequestStatuses";

export const RequestHistoryItem = ({eventItem}) => {
  // console.groupCollapsed('HistoryItem')
  // console.log('item', item)
  // console.log('changeLog', item.changeLog)
  // console.log('eventItem', eventItem)
  // console.groupEnd()

  const shouldShowExternalNote = !isInternal() && !isProjectReadOnlyRole() && eventItem.notesIsExternal;
  const externalNoteText =
    eventItem.internalStatus === REQUEST_STATUSES.ADDITIONAL_INFORMATION_RECEIVED && shouldShowExternalNote
      ? REQUEST_NOTES.ADDITIONAL_DOCUMENTS_SUBMITTED
      : (shouldShowExternalNote ? eventItem.notes : "");

  return (
    <div className="stack-item request-event-item">
      <div className="stack-cell">
        <div className="stack-cell-header">Status Update</div>
        <div className="stack-cell-value">
          {( isInternal() || isProjectReadOnlyRole() )
          ? eventItem.internalStatus
          : (eventItem.externalStatus)
          }
        </div>
      </div>
      <div className="stack-cell">
        <div className="stack-cell-header">Date</div>
        <div className="stack-cell-value">{eventItem.createdDate ? moment(eventItem.createdDate).format("MM/DD/YY") : ""}</div>
      </div>
      {( isInternal() || isProjectReadOnlyRole() ) && (
        <>
        <div className="stack-cell">
          <div className="stack-cell-header">Updated By</div>
          <div className="stack-cell-value">{eventItem.createdByName || eventItem.createdByLdapId}</div>
        </div>
      
        <div className="stack-cell">
          <div className="stack-cell-header">Assigned To</div>
          <div className="stack-cell-value">{eventItem.assignedToName || eventItem.assignedToLdapId}</div>
        </div>
        </>
      )}
      <div className="stack-cell note-cell" style={{flex: 4}}>
        <div className="stack-cell-header">Note</div>
        <div className="stack-cell-value comment-body">
          {( isInternal() || isProjectReadOnlyRole() )
            ? eventItem.notes
            : externalNoteText}
        </div>
      </div>
    </div>
  );
};